module.exports = __webpack_public_path__ + "static/img/zwfw.f4bd95d2.png";